import React, { Component } from 'react';
import { Container, Alert } from 'reactstrap';

class RegisterSucceed extends Component {

    componentDidMount() {
        localStorage.clear();
    }

    render() {
        return (
            <Container>
                <h1>Pendaftaran Nasabah Berhasil</h1>
                <Alert color="success">Pendaftaran Anda berhasil, kami akan memproses data Anda.</Alert>
                <Alert color="success">Kode referensi Anda: <b>{new URLSearchParams(window.location.href.split('?')[1])}</b></Alert>
            </Container>
        );
    }
}

export default RegisterSucceed;



// WEBPACK FOOTER //
// ./src/components/RegisterSucceed.js